import React, { useState } from 'react';
import { Checkbox, Grid, GridCol } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { useSelector } from 'react-redux';
import { AppState } from '../../../client-redux/reducers';
import { Language } from '../../../languages/languageHandler';
import { UseFormReturnType } from '@mantine/form';
import { ICurrency } from '../../../../libraries/currencies';
import CurrencyInput from '../../../components/currency-input';
import './styles.scss';

export enum MODE {
  READ = 'read',
  EDIT = 'edit',
  NEW = 'new'
}

interface ContractCheckboxProps {
  label: string;
  selected: boolean;
  value: number;
  date: Date | null;
  disabled: boolean;
  form: UseFormReturnType<any>;
  field: string;
  onChange: (newValue: boolean) => void;
}

const ContractCheckbox: React.FC<ContractCheckboxProps> = ({ label, selected, date, disabled, form, field }) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const currencies = useSelector<AppState, ICurrency[]>(state => state.currencies.currencies);
  const currency = currencies.find(c => c.currencyStr === 'EUR')!;

  const [isChecked, setIsChecked] = useState<boolean>(selected);

  const handleCheckboxChange = (newValue: boolean) => {
    setIsChecked(newValue);
    form.setFieldValue(field, newValue);
    onChange?.(newValue);
  };

  const checkboxInputProps = form.getInputProps(field);
  const { onChange, ...restProps } = checkboxInputProps;

  return (
    <Grid className="contract-checkbox">
      <GridCol span={{ base: 12, md: 4, lg: 4 }} className={isChecked ? 'checkbox-checked' : 'checkbox-unchecked'}>
        <Checkbox
          checked={isChecked || selected}
          labelPosition="left"
          label={label}
          disabled={disabled}
          onChange={e => handleCheckboxChange(e.currentTarget.checked)}
          {...restProps}
        />
      </GridCol>

      {selected && (
        <>
          <GridCol span={{ base: 12, sm: 4, md: 4, lg: 4 }}>
            <CurrencyInput
              label={lang.HELPDESK_VALUE}
              value={form.values[`${field}Value`] ?? 0}
              currencySymbol={currency.currencyStr}
              showSymbol={true}
              disabled={disabled}
              onChange={cents => {
                form.setFieldValue(`${field}Value`, cents);
              }}
            />
          </GridCol>

          <GridCol span={{ base: 12, sm: 4, md: 4, lg: 4 }}>
            <DateInput
              label={lang.HELPDESK_DATE}
              value={date && new Date(date).getTime() ? new Date(date) : null}
              disabled={disabled}
              placeholder={date ? new Date(date).toLocaleString() : lang.EVENT_BEGIN_DATE}
              {...form.getInputProps(`${field}Date`)}
            />
          </GridCol>
        </>
      )}
    </Grid>
  );
};

export default ContractCheckbox;
